interface Props {
  [key: string]: any
}

export default function ArrowCircleIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 12 14" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M9.46018 1.44531L11.2163 3.20141L9.46018 4.95751M2.43579 13.1526L0.679688 11.3965L2.43579 9.64043"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.17073"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M11.2163 3.20312H4.77725C3.69051 3.20313 2.64828 3.63483 1.87984 4.40327C1.11139 5.17171 0.679688 6.21395 0.679688 7.30069M0.679688 11.3982H7.11871C8.20545 11.3982 9.24768 10.9665 10.0161 10.1981C10.7846 9.42966 11.2163 8.38743 11.2163 7.30069"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.17073"
      />
    </svg>
  )
}
